module.exports = __webpack_public_path__ + "img/image-gauche.eec15ce8.jpg";